import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TablePagination } from "../../../../common/details-table/table-pagination.component";
import ButtonIcon from "../../../../button";
import { MODAL_CUSTOM_MESSAGE } from "../../../../../constants/external-constants";
import { orderHistoryActions } from "../../../../../store/external/order/history/order-history.reducer";

class OrderHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }
    }

    componentDidMount() {
        const { orderId, requestTypeId, quotationRequestId } = this.props;
        this.props.getOrderHistoryLogs(orderId, requestTypeId, quotationRequestId)
    }

    componentWillUnmount() {
        this.props.resetOrderHistory();
    }

    onColumnSearch = () => {
        const { getOrderHistoryLogs, orderId, requestTypeId, quotationRequestId } = this.props;
        getOrderHistoryLogs(orderId, requestTypeId, quotationRequestId, 0)
    }

    orderPaginationAction = (pageIndex) => {
        const { getOrderHistoryLogs, orderId, requestTypeId, quotationRequestId } = this.props;
        getOrderHistoryLogs(orderId, requestTypeId, quotationRequestId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeOrderHistoryLogs, getOrderHistoryLogs, orderId, requestTypeId, quotationRequestId } = this.props;
        resizeOrderHistoryLogs(pageSize)
        getOrderHistoryLogs(orderId, requestTypeId, quotationRequestId);
    }

    render() {

        const { setOrderHistoryColSearchStr, isColSearchShow } = this.props;
        const { IsLoadingTable } = this.props.orderHistory;
        const { Headers, Data, Pagination } = this.props.orderHistory.HistoryTable;


        return (
            <>

                <TablePagination
                    key="table-pagination-key"
                    columns={Headers}
                    pageList={Data}
                    pages={Pagination}
                    paginationAction={this.orderPaginationAction}
                    onColumnSearch={this.onColumnSearch}
                    onColumnSearchChange={setOrderHistoryColSearchStr}
                    isColSearchShow={isColSearchShow}
                    resizePage={this.resizePage}
                    totalPage={Pagination.TotalEntries}
                    isNotSortable={true}
                    isLoading={IsLoadingTable}
                    hideStatusIcon={true}
                />
            </>
        );
    }
}

export default connect(
    state => {
        const { orderHistory } = state;
        return {
            orderHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, orderHistoryActions),
        dispatch
    )
)(OrderHistory);